import { useMobileMenu } from "@platform/store";
import { PlatformHeader } from "./PlatformHeader";

export type Props = {
  children?: React.ReactNode;
};

export function PlatformHeaderContainer({ children }: Props) {
  const {
    isOpen: isMobileMenuOpen,
    open: openMobileMenu,
    close: closeMobileMenu,
  } = useMobileMenu();

  return (
    <PlatformHeader
      onMenuClick={openMobileMenu}
      closeMobileMenu={closeMobileMenu}
      isMobileMenuOpen={isMobileMenuOpen}
    >
      {children}
    </PlatformHeader>
  );
}

export default PlatformHeaderContainer;

